import React from "react";
import Image from "../shared/Image";
import Link from "../shared/Link";

const SwiperItem = (props) => {
  const { item } = props;

  return (
    <Link
      className=""
      hasLink="true"
      link={item?.link || item?.url}
      productId={""}
      newWindow={item?.newWindow}
    >
      <Image
        alt={!!item?.Name ? item?.Name : "no title"}
        src={item?.urlToImage}
      />
      <span className="data-of-image">
        <span className="wrap">
          <span className="text-block">
            <span className="title text-animation">{item?.title}</span>
            <span className="subtitle text-animation">{item?.description}</span>
          </span>
        </span>
      </span>
    </Link>
  );
};

export default SwiperItem;
